<markant-platform-modal-bridge>
  <markant-dialog
    *ngIf="open"
    [open]="true"
    [headTitle]="headTitle$ | async"
    (close)="closeDialog()"
  >
    <div>{{ text$ | async }}</div>
    <div slot="footer">
      <markant-button (click)="buttonCallback()">{{
        buttonLabel$ | async
      }}</markant-button>
    </div>
  </markant-dialog>
</markant-platform-modal-bridge>
